import { IPrefecture } from '../../../../core/src'
import { BaseStoreFactory } from './factories/base-store.factory'

export const getPrefectureStore = BaseStoreFactory.Create<IPrefecture>('prefecture')
